module.exports = __webpack_public_path__ + "img/pt-deck.4f12c6b8.png";